import React from 'react';
import { connect } from 'react-redux';
import VersionsContainer from './versions-container';
import { fetchPageVersion, makeLatest } from '../../../state/actions/simple-editor';

const VersionsRedux = (props) => (
  <VersionsContainer {...props}/>
);

const mapStateToProps = (state, ownProps) => {
  const {entityId:id} = ownProps;
  const pathMap = state.pages.page.paths || {};
  const currentPaths = pathMap[id] || [];
  return {
    paths: currentPaths,
    saved: state.pages.page.editor.saved,
    published: state.published[id] && state.published[id].current,
  }
};

const mapDispatchToProps = (dispatch) => ({
  makeLatest: (id, version) => dispatch(makeLatest(id, version)),
  onFetchVersion: (id, version) => dispatch(fetchPageVersion(id, version)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VersionsRedux);
